import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BauprojektDossiernummerRequestMeta, GwrbauprojektService } from '../../../../core/gwr-api';
import { FormsModule, NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { GwrFormService } from '../../../gwr-form.service';
import { BauortComponent } from '../../../../shared/widgets/bauort/bauort.component';
import { AbstractSearchComponent } from '../../../../shared/components/abstract-component/abstract-search.component';
import { SearchStateService } from '../../../../shared/services/search-state.service';
import { SearchMode } from '../../../../shared/enum/searchMode';
import { MetaDirective } from '../../../../shared/directives/meta.directive';
import { CapFormRowDirective } from '../../../../shared/form-control/cap-form-row.directive';
import { CapFormControlComponent } from '../../../../shared/form-control/form-control.component';
import { MetaDisablerDirective } from '../../../../shared/directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../../../shared/directives/meta-validator.directive';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-gwr-bauprojekt-suche-dossiernummer',
  templateUrl: './gwr-bauprojekt-suche-dossiernummer.component.html',
  styleUrls: ['./gwr-bauprojekt-suche-dossiernummer.component.scss'],
  imports: [
    FormsModule,
    MetaDirective,
    CapFormRowDirective,
    CapFormControlComponent,
    BauortComponent,
    MetaDisablerDirective,
    MetaValidatorDirective,
    TranslatePipe
  ]
})
export class GwrBauprojektSucheDossiernummerComponent extends AbstractSearchComponent implements OnInit, OnDestroy {
  @ViewChild('form', { static: false })
  form: NgForm;

  @ViewChild(BauortComponent, { static: false })
  private bauort: BauortComponent;

  dossiernummer: BauprojektDossiernummerRequestMeta;
  private subscription: Subscription;
  onTouched: () => void;

  constructor(
    stateService: SearchStateService,
    private bauprojektService: GwrbauprojektService,
    private formService: GwrFormService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    super(stateService);
  }

  ngOnInit() {
    this.subscription = this.bauprojektService.searchBauprojektDossiernummerTemplate().subscribe((template) => {
      this.dossiernummer = this.copyLastRequest(template, SearchMode.searchDossiernummer);
    });
  }

  onSubmit(): void {
    this.stateService.lastSearchMode = SearchMode.searchDossiernummer;
    this.stateService.lastRequest = this.dossiernummer;
    this.formService.submit(this.form, SearchMode.searchDossiernummer, this.dossiernummer, this.router, this.route, true);
  }

  onReset() {
    this.form.reset();
    this.subscription = this.bauprojektService.searchBauprojektDossiernummerTemplate().subscribe((template) => {
      this.dossiernummer = template;
      this.bauort.focus();
      this.bauort.ngOnInit();
    });
  }

  emptyBauorteSearch() {
    this.bauort.onClear();
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
